/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateAppointmentFileReference = /* GraphQL */ `subscription OnCreateAppointmentFileReference(
  $filter: ModelSubscriptionAppointmentFileReferenceFilterInput
) {
  onCreateAppointmentFileReference(filter: $filter) {
    id
    appointmentID
    uploadedFileID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAppointmentFileReferenceSubscriptionVariables,
  APITypes.OnCreateAppointmentFileReferenceSubscription
>;
export const onUpdateAppointmentFileReference = /* GraphQL */ `subscription OnUpdateAppointmentFileReference(
  $filter: ModelSubscriptionAppointmentFileReferenceFilterInput
) {
  onUpdateAppointmentFileReference(filter: $filter) {
    id
    appointmentID
    uploadedFileID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAppointmentFileReferenceSubscriptionVariables,
  APITypes.OnUpdateAppointmentFileReferenceSubscription
>;
export const onDeleteAppointmentFileReference = /* GraphQL */ `subscription OnDeleteAppointmentFileReference(
  $filter: ModelSubscriptionAppointmentFileReferenceFilterInput
) {
  onDeleteAppointmentFileReference(filter: $filter) {
    id
    appointmentID
    uploadedFileID
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAppointmentFileReferenceSubscriptionVariables,
  APITypes.OnDeleteAppointmentFileReferenceSubscription
>;
export const onCreateUploadedFile = /* GraphQL */ `subscription OnCreateUploadedFile(
  $filter: ModelSubscriptionUploadedFileFilterInput
) {
  onCreateUploadedFile(filter: $filter) {
    id
    key
    fileName
    type
    provider
    uploadedBy
    uploadedAt
    fileSizeBytes
    fileSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    fileSetID
    sourceAppointmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUploadedFileSubscriptionVariables,
  APITypes.OnCreateUploadedFileSubscription
>;
export const onUpdateUploadedFile = /* GraphQL */ `subscription OnUpdateUploadedFile(
  $filter: ModelSubscriptionUploadedFileFilterInput
) {
  onUpdateUploadedFile(filter: $filter) {
    id
    key
    fileName
    type
    provider
    uploadedBy
    uploadedAt
    fileSizeBytes
    fileSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    fileSetID
    sourceAppointmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUploadedFileSubscriptionVariables,
  APITypes.OnUpdateUploadedFileSubscription
>;
export const onDeleteUploadedFile = /* GraphQL */ `subscription OnDeleteUploadedFile(
  $filter: ModelSubscriptionUploadedFileFilterInput
) {
  onDeleteUploadedFile(filter: $filter) {
    id
    key
    fileName
    type
    provider
    uploadedBy
    uploadedAt
    fileSizeBytes
    fileSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    fileSetID
    sourceAppointmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUploadedFileSubscriptionVariables,
  APITypes.OnDeleteUploadedFileSubscription
>;
export const onCreateDocument = /* GraphQL */ `subscription OnCreateDocument($filter: ModelSubscriptionDocumentFilterInput) {
  onCreateDocument(filter: $filter) {
    id
    uploadedFileID
    providerTag
    pageCount
    executionArn
    recordBriefingId
    segmentSplits
    segmentIntervals {
      startPageNumber
      endPageNumber
      startLineNumber
      endLineNumber
      confidence
      confidenceReasoning
      edited
      needsReSummary
      __typename
    }
    segmentIntervalRows {
      items {
        id
        documentID
        startPageNumber
        endPageNumber
        startLineNumber
        endLineNumber
        confidence
        confidenceReasoning
        edited
        needsReSummary
        archived
        parentIntervals
        lastEditAction
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    pages {
      items {
        id
        documentID
        pageNumber
        imageS3Key
        text
        isBlank
        citations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    preview {
      bucket
      key
      __typename
    }
    hasUnresolvedSplits
    videoDurationSeconds
    ingestionSteps {
      items {
        id
        documentID
        name
        status
        startedAt
        endedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    documentMrrValidationId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDocumentSubscriptionVariables,
  APITypes.OnCreateDocumentSubscription
>;
export const onUpdateDocument = /* GraphQL */ `subscription OnUpdateDocument($filter: ModelSubscriptionDocumentFilterInput) {
  onUpdateDocument(filter: $filter) {
    id
    uploadedFileID
    providerTag
    pageCount
    executionArn
    recordBriefingId
    segmentSplits
    segmentIntervals {
      startPageNumber
      endPageNumber
      startLineNumber
      endLineNumber
      confidence
      confidenceReasoning
      edited
      needsReSummary
      __typename
    }
    segmentIntervalRows {
      items {
        id
        documentID
        startPageNumber
        endPageNumber
        startLineNumber
        endLineNumber
        confidence
        confidenceReasoning
        edited
        needsReSummary
        archived
        parentIntervals
        lastEditAction
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    pages {
      items {
        id
        documentID
        pageNumber
        imageS3Key
        text
        isBlank
        citations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    preview {
      bucket
      key
      __typename
    }
    hasUnresolvedSplits
    videoDurationSeconds
    ingestionSteps {
      items {
        id
        documentID
        name
        status
        startedAt
        endedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    documentMrrValidationId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDocumentSubscriptionVariables,
  APITypes.OnUpdateDocumentSubscription
>;
export const onCreateOperationStatus = /* GraphQL */ `subscription OnCreateOperationStatus(
  $filter: ModelSubscriptionOperationStatusFilterInput
) {
  onCreateOperationStatus(filter: $filter) {
    id
    scope
    operation
    name
    status
    startedAt
    heartbeatAt
    endedAt
    attempt
    errorMessage
    correlationId
    metadata
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOperationStatusSubscriptionVariables,
  APITypes.OnCreateOperationStatusSubscription
>;
export const onUpdateOperationStatus = /* GraphQL */ `subscription OnUpdateOperationStatus(
  $filter: ModelSubscriptionOperationStatusFilterInput
) {
  onUpdateOperationStatus(filter: $filter) {
    id
    scope
    operation
    name
    status
    startedAt
    heartbeatAt
    endedAt
    attempt
    errorMessage
    correlationId
    metadata
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOperationStatusSubscriptionVariables,
  APITypes.OnUpdateOperationStatusSubscription
>;
export const onCreateDocumentPage = /* GraphQL */ `subscription OnCreateDocumentPage(
  $filter: ModelSubscriptionDocumentPageFilterInput
) {
  onCreateDocumentPage(filter: $filter) {
    id
    documentID
    pageNumber
    imageS3Key
    text
    isBlank
    citations {
      items {
        id
        documentPageID
        documentID
        pageNumber
        blockIndex
        text
        bbox {
          yMin
          xMin
          yMax
          xMax
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDocumentPageSubscriptionVariables,
  APITypes.OnCreateDocumentPageSubscription
>;
export const onUpdateDocumentPage = /* GraphQL */ `subscription OnUpdateDocumentPage(
  $filter: ModelSubscriptionDocumentPageFilterInput
) {
  onUpdateDocumentPage(filter: $filter) {
    id
    documentID
    pageNumber
    imageS3Key
    text
    isBlank
    citations {
      items {
        id
        documentPageID
        documentID
        pageNumber
        blockIndex
        text
        bbox {
          yMin
          xMin
          yMax
          xMax
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDocumentPageSubscriptionVariables,
  APITypes.OnUpdateDocumentPageSubscription
>;
export const onCreateNotes = /* GraphQL */ `subscription OnCreateNotes($filter: ModelSubscriptionNotesFilterInput) {
  onCreateNotes(filter: $filter) {
    id
    content
    author {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    type
    timeStamp
    appointmentrecordID
    createdAt
    updatedAt
    notesAuthorId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateNotesSubscriptionVariables,
  APITypes.OnCreateNotesSubscription
>;
export const onUpdateNotes = /* GraphQL */ `subscription OnUpdateNotes($filter: ModelSubscriptionNotesFilterInput) {
  onUpdateNotes(filter: $filter) {
    id
    content
    author {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    type
    timeStamp
    appointmentrecordID
    createdAt
    updatedAt
    notesAuthorId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateNotesSubscriptionVariables,
  APITypes.OnUpdateNotesSubscription
>;
export const onUpdateHuddleNote = /* GraphQL */ `subscription OnUpdateHuddleNote(
  $filter: ModelSubscriptionHuddleNoteFilterInput
) {
  onUpdateHuddleNote(filter: $filter) {
    id
    appointmentRecordID
    contentMarkdown
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHuddleNoteSubscriptionVariables,
  APITypes.OnUpdateHuddleNoteSubscription
>;
export const onUpdateUser = /* GraphQL */ `subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
  onUpdateUser(filter: $filter) {
    id
    cognitoUserId
    avatarUrl
    firstName
    lastName
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    assistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    appointmentFilterPreset {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    onboardingDismissals {
      itemId
      dismissedAt
      __typename
    }
    settings {
      opsChecklistDefaultExpanded
      __typename
    }
    createdAt
    updatedAt
    userDoctorId
    userAssistantId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserSubscriptionVariables,
  APITypes.OnUpdateUserSubscription
>;
export const onCreateCaseRecord = /* GraphQL */ `subscription OnCreateCaseRecord(
  $filter: ModelSubscriptionCaseRecordFilterInput
) {
  onCreateCaseRecord(filter: $filter) {
    id
    state
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCaseRecordSubscriptionVariables,
  APITypes.OnCreateCaseRecordSubscription
>;
export const onUpdateCaseRecord = /* GraphQL */ `subscription OnUpdateCaseRecord(
  $filter: ModelSubscriptionCaseRecordFilterInput
) {
  onUpdateCaseRecord(filter: $filter) {
    id
    state
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCaseRecordSubscriptionVariables,
  APITypes.OnUpdateCaseRecordSubscription
>;
export const onDeleteCaseRecord = /* GraphQL */ `subscription OnDeleteCaseRecord(
  $filter: ModelSubscriptionCaseRecordFilterInput
) {
  onDeleteCaseRecord(filter: $filter) {
    id
    state
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCaseRecordSubscriptionVariables,
  APITypes.OnDeleteCaseRecordSubscription
>;
export const onUpdateAppointmentRecord = /* GraphQL */ `subscription OnUpdateAppointmentRecord(
  $filter: ModelSubscriptionAppointmentRecordFilterInput
  $doctorOwnerCognitoId: String
) {
  onUpdateAppointmentRecord(
    filter: $filter
    doctorOwnerCognitoId: $doctorOwnerCognitoId
  ) {
    id
    doctorOwnerCognitoId
    assistantCognitoIds
    globalPartitionKey
    originalAppointmentID
    supplementalAppointmentIDs
    supplementalSourceAppointmentIDs
    depositionAppointmentIDs
    depositionSourceAppointmentIDs
    rescheduledFromAppointmentID
    rescheduledToAppointmentID
    date
    yearMonth
    doctorYearMonth
    time
    bookedInFlexibleTime
    inquiryDate
    inquiryYearMonth
    type
    doctorID
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    locationID
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    visitForm
    jotformSubmissions {
      id
      receivedAt
      populatedAt
      __typename
    }
    historyTranscriptPopulations {
      uploadedFileID
      populatedAt
      __typename
    }
    active
    durationMinutes
    reportDue
    reportSubmitted
    status
    reportStatus
    paymentStatus
    billingStatus
    difficultyLevel
    scheduler {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    schedulingAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    onSiteOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    reportOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    billingOp {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    preVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    inquirerInfo {
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      inquiringParty
      name
      inquiryDate
      notification_110_required
      __typename
    }
    notes {
      items {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      nextToken
      __typename
    }
    huddleNote {
      id
      appointmentRecordID
      contentMarkdown
      createdAt
      updatedAt
      __typename
    }
    patientCases {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    employments {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    employmentGaps {
      type
      startDate {
        value
        precision
        __typename
      }
      endDate {
        value
        precision
        __typename
      }
      notes
      __typename
    }
    patientDescribedInjuries
    uploadedFilesSet {
      id
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          fileName
          type
          provider
          uploadedBy
          uploadedAt
          fileSizeBytes
          fileSetID
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    uploadedFilesSetID
    referredBy
    s3FileKey
    medicalRecordsReceived
    medicalRecordsBriefingFileID
    medicalRecordsBriefingExecutionArn
    medicalRecordsTotalPagesProcessed
    reportGenerationFileID
    reportGenerationExecutionArn
    reportGenerationGeneratedAt
    historyOfInjuryFileID
    historyOfInjuryGeneratedAt
    evaluationFileID
    assessmentFileID
    depositionPreparationFileID
    documentStatus {
      evaluationPublished
      assessmentPublished
      historyInProgress
      historyPublished
      historyCleaned
      reportPublished
      briefingInProgress
      briefingPublished
      briefingCleaned
      __typename
    }
    cancellationReason
    cancellationRequestedBy
    cancellationRequestedInternally
    cancellationNote
    cancellationDate
    inquiryClosingReason
    inquiryClosingNote
    inquiryClosingDate
    noShowReason
    noShowNote
    reschedulingReason
    reschedulingOthersReason
    reschedulingRequestedBy
    reschedulingRequestedInternally
    reschedulingNote
    reschedulingDate
    interpreter {
      certificateId
      name
      companyName
      phoneNumber
      phoneExtension
      note
      confirmed
      __typename
    }
    historyOfInjuryNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    currentComplaintNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      type
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    historyCallDate
    historyCallTime
    historyCallAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    historyCallCompleted
    historyCallCompletedWithoutRecords
    historyCallCompletedOnSite
    historyCallNoShow
    historyCallCalendarEventID
    historyCallCalendarLink
    billingInfo {
      diagnosisMappings {
        code
        pointer
        description
        __typename
      }
      serviceDetails {
        dateOfStart
        dateOfEnd
        place
        emergencyIndicator
        serviceType
        modifiers
        diagnosisPointers
        chargedAmount
        quantity
        amountPaid
        renderingProviderId
        __typename
      }
      totalCharge
      amountPaid
      billingCounter
      billedDate
      paidDate
      correctionDate
      __typename
    }
    caseInfo {
      confirmationEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      recordsFollowupEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      attendanceEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      __typename
    }
    isProd
    isDemo
    primaryPatientCaseID
    calendarEventID
    reportConfiguration {
      history
      physicalExamination
      assessment
      __typename
    }
    workflowExecutions {
      items {
        executionArn
        appointmentRecordID
        type
        status
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    historyOfInjuryInsights {
      id
      appointmentRecordID
      mechanismOfInjury
      employerJobDescription
      injuryCausations {
        injuryType
        dateOfInjury
        dateOfInjuryEnd
        bodyParts
        mechanismOfInjury
        employerJobDescription
        __typename
      }
      currentSymptoms {
        bodyParts
        description
        __typename
      }
      priorSymptomsBeforeCurrentInjury {
        bodyParts
        description
        __typename
      }
      previousSurgeries {
        date
        bodyParts
        type
        __typename
      }
      previousWorkInjuries {
        date
        bodyParts
        description
        __typename
      }
      previousInjuries {
        date
        bodyParts
        description
        __typename
      }
      injuryEmploymentStatus
      currentWorkRestrictionsFromPatient
      activitiesOfDailyLiving
      createdAt
      updatedAt
      __typename
    }
    reviewOfMedicalRecordsInsights {
      id
      appointmentRecordID
      latestDiagnosis {
        bodyPart
        date
        descriptions
        __typename
      }
      diagnosticStudies {
        date
        typeOfStudy
        bodyPart
        impression
        source
        __typename
      }
      treatments {
        discreteTreatment {
          date
          treatmentType
          bodyPart
          description
          __typename
        }
        recurringTreatment {
          year
          treatmentType
          frequency
          description
          __typename
        }
        __typename
      }
      currentWorkRestrictionsFromMedicalRecords
      previousReports {
        date
        reportType
        reportContent
        __typename
      }
      durableMedicalEquipment {
        startDate
        endDate
        bodyParts
        equipmentType
        description
        __typename
      }
      derivedFromDocumentInsightIDs
      derivedAt
      createdAt
      updatedAt
      __typename
    }
    physicalExamInsights {
      id
      appointmentRecordID
      physicalExaminationInfo
      createdAt
      updatedAt
      __typename
    }
    pastInjuryMatrix {
      id
      appointmentRecordID
      preExistingConditions
      familyHistory
      injuryMatrix {
        date
        bodyPart
        status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    briefing {
      id
      logicalBriefingID
      segmentMappings {
        items {
          id
          briefingID
          logicalSegmentID
          publishedSegmentID
          draftSegmentID
          markedForDeletion
          markedForCreation
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      generatedAt
      lastEditedAt
      lastEditedBy
      googleDocExportLink
      googleDocExportedAt
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
        __typename
      }
      editingPresence
      createdAt
      updatedAt
      __typename
    }
    introParagraph {
      id
      appointmentRecordID
      introParagraphText
      sourceRecaps {
        coverLetterRecapID
        uploadedFileID
        recapText
        generatedAt
        __typename
      }
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
    impairmentRatingResults {
      ts
      bodyParts
      enabledStrictRating
      enabledPainRating
      enabledAG
      enabledStrengthRating
      enabledDBE
      autoMode
      result
      resultFeedback {
        exists
        isGood
        notes
        __typename
      }
      __typename
    }
    defenseAttorneyPagesDeclaration
    applicantAttorneyPagesDeclaration
    fieldTemplateRef {
      id
      version
      __typename
    }
    dataFieldValuesMappings {
      dataFieldID
      value
      __typename
    }
    physicalEvalTemplateRef {
      id
      version
      __typename
    }
    physicalExamValues {
      sectionID
      questionID
      side
      value
      note
      excluded
      __typename
    }
    physicalExamOtherFindings {
      sectionID
      text
      __typename
    }
    assessment {
      id
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussedBodyParts
      bodyPartsNotDiscussedReason
      discussions
      diagnoses {
        diagnosis
        icdCode
        evidenceSources
        evidence
        __typename
      }
      bodyPartMMIStatus {
        discussByBodyPart
        allBodyPartsMMI {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        bodyPartMMIStatuses {
          bodyPart
          __typename
        }
        __typename
      }
      workStatus
      markedAsDone
      discussDiagnosesFreeForm
      diagnosesFreeform
      discussCausationFreeForm
      causationFreeForm
      discussMMIImpairmentRatingApportionmentFreeForm
      hasPatientReachedMMIFreeForm
      discussMMIByBodyPartFreeForm
      impairmentRatingByBodyPartFreeForm
      apportionmentByBodyPartFreeForm
      impairmentRatingOtherComments
      apportionmentOtherComments
      assessmentMode
      assessmentFreeForm {
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussions
        diagnosesAndEvidence
        causation
        hasPatientReachedMMI
        discussMMIByBodyPart
        impairmentRatingByBodyPart
        apportionmentByBodyPart
        workStatus
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    assessmentValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    opinionRecap {
      id
      appointmentRecordID
      causation
      diagnosis
      mmiFutureMedicalTreatment
      impairmentRating
      apportionment
      workStatus
      sourceReportFileID
      createdAt
      updatedAt
      __typename
    }
    tempUploadedIntakeFormS3Keys
    featureFlags {
      featureFlagKey
      enabled
      __typename
    }
    opsChecklist {
      panel
      contact_info
      all_parties
      notice_110
      cover_letter
      record_review
      history_call
      history_of_injury
      interpreter_info
      jotform
      deu_100
      final_report
      __typename
    }
    panelUnavailable
    panelSpecialty
    defenseAttorneyNotPresent
    applicantAttorneyNotPresent
    contactUnavailability {
      patient {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      adjuster {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      applicantAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      defenseAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      __typename
    }
    historyValidation {
      id
      appointmentRecordID
      status
      groups {
        id
        title
        status
        issues {
          id
          title
          description
          patientInfoSection
          issueType
          __typename
        }
        __typename
      }
      validatedAt
      errorMessage
      createdAt
      updatedAt
      __typename
    }
    patientHistoryValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    videoCallLink
    additionalTimeslots {
      date
      time
      locationID
      __typename
    }
    mrrValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    historyMrrCrossValidation {
      id
      issueGroups
      issues {
        items {
          id
          validationID
          validationCheckID
          title
          issue
          status
          resourceURI
          issueGroup
          issueType
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    caseID
    briefingModelVersion
    briefingGdocExportLink
    briefingGdocExportedAt
    createdAt
    updatedAt
    appointmentRecordMedicalAssistantId
    appointmentRecordSchedulingAssistantId
    appointmentRecordOnSiteOpId
    appointmentRecordReportOpId
    appointmentRecordBillingOpId
    appointmentRecordPreVisitReviewerId
    appointmentRecordHuddleNoteId
    appointmentRecordHistoryOfInjuryNotesId
    appointmentRecordCurrentComplaintNotesId
    appointmentRecordHistoryCallAssistantId
    appointmentRecordHistoryOfInjuryInsightsId
    appointmentRecordReviewOfMedicalRecordsInsightsId
    appointmentRecordPhysicalExamInsightsId
    appointmentRecordPastInjuryMatrixId
    appointmentRecordBriefingId
    appointmentRecordIntroParagraphId
    appointmentRecordAssessmentId
    appointmentRecordAssessmentValidationId
    appointmentRecordOpinionRecapId
    appointmentRecordHistoryValidationId
    appointmentRecordPatientHistoryValidationId
    appointmentRecordMrrValidationId
    appointmentRecordHistoryMrrCrossValidationId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAppointmentRecordSubscriptionVariables,
  APITypes.OnUpdateAppointmentRecordSubscription
>;
export const onCreatePatientCase = /* GraphQL */ `subscription OnCreatePatientCase(
  $filter: ModelSubscriptionPatientCaseFilterInput
) {
  onCreatePatientCase(filter: $filter) {
    id
    patientID
    patient {
      id
      name
      dateOfBirth
      SSN
      language
      dominantHand
      cases {
        items {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      occupation
      sex
      weightLb
      height {
        feet
        inches
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    claimNumber
    qmePanelNumber
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    injuryInfo {
      injuryType
      injuredBodyParts
      claimedBodyParts
      description
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      startDateOfInjury
      startDateOfInjuryFlexible {
        value
        precision
        __typename
      }
      __typename
    }
    workersCompInsurance {
      insuranceCarrier
      adjuster
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    insuranceCarrierID
    insuranceCarrier {
      id
      name
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierAddressID
    insuranceCarrierAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierFaxNumberID
    insuranceCarrierFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierPhoneNumberID
    insuranceCarrierPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    appointments {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    applicantAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyLawFirmID
    applicantAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyAddressID
    applicantAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyFaxNumberID
    applicantAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyPhoneNumberID
    applicantAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    defenseAttorneyLawFirmID
    defenseAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyAddressID
    defenseAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyFaxNumberID
    defenseAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyPhoneNumberID
    defenseAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nurseCaseManager {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    ccPerson {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyCcEmails
    defenseAttorneyCcEmails
    adjusterCcEmails
    scheduledCommsSuppressedParties
    employmentAtInjury {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    WCAB
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePatientCaseSubscriptionVariables,
  APITypes.OnCreatePatientCaseSubscription
>;
export const onUpdatePatientCase = /* GraphQL */ `subscription OnUpdatePatientCase(
  $filter: ModelSubscriptionPatientCaseFilterInput
) {
  onUpdatePatientCase(filter: $filter) {
    id
    patientID
    patient {
      id
      name
      dateOfBirth
      SSN
      language
      dominantHand
      cases {
        items {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      occupation
      sex
      weightLb
      height {
        feet
        inches
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    claimNumber
    qmePanelNumber
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    injuryInfo {
      injuryType
      injuredBodyParts
      claimedBodyParts
      description
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      startDateOfInjury
      startDateOfInjuryFlexible {
        value
        precision
        __typename
      }
      __typename
    }
    workersCompInsurance {
      insuranceCarrier
      adjuster
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    insuranceCarrierID
    insuranceCarrier {
      id
      name
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierAddressID
    insuranceCarrierAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierFaxNumberID
    insuranceCarrierFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    insuranceCarrierPhoneNumberID
    insuranceCarrierPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    appointments {
      items {
        id
        appointmentRecordId
        patientCaseId
        appointmentRecord {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        patientCase {
          id
          patientID
          claimNumber
          qmePanelNumber
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          WCAB
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        doctorOwnerCognitoId
        assistantCognitoIds
        __typename
      }
      nextToken
      __typename
    }
    applicantAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyLawFirmID
    applicantAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyAddressID
    applicantAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyFaxNumberID
    applicantAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    applicantAttorneyPhoneNumberID
    applicantAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorney {
      name
      lawFirmName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    defenseAttorneyLawFirmID
    defenseAttorneyLawFirm {
      id
      name
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultEmail
      supportedDomains
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyAddressID
    defenseAttorneyAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyFaxNumberID
    defenseAttorneyFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    defenseAttorneyPhoneNumberID
    defenseAttorneyPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nurseCaseManager {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    ccPerson {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    applicantAttorneyCcEmails
    defenseAttorneyCcEmails
    adjusterCcEmails
    scheduledCommsSuppressedParties
    employmentAtInjury {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      stillWorkingHere
      type
      currentWorkRestrictions
      workStatus
      departureReason
      __typename
    }
    WCAB
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePatientCaseSubscriptionVariables,
  APITypes.OnUpdatePatientCaseSubscription
>;
export const onUpdateDoctor = /* GraphQL */ `subscription OnUpdateDoctor(
  $filter: ModelSubscriptionDoctorFilterInput
  $ownerCognitoId: String
) {
  onUpdateDoctor(filter: $filter, ownerCognitoId: $ownerCognitoId) {
    id
    ownerCognitoId
    firstName
    middleName
    lastName
    name
    signatureName
    status
    ramped
    title
    titleExtension
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    officePhone
    cellPhone
    clinicPhone
    workCity
    workState
    collectionRate
    licenseNumber
    licenseRenewalDate
    qmeLicense {
      licenseNumber
      approvalDate
      renewalDate
      __typename
    }
    locations {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    specialties
    npi
    bankingInfo {
      bankEntityName
      accountNumber
      routingNumber
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    availabilities {
      generalAvailabilities {
        during {
          start
          end
          __typename
        }
        recurrence
        dayOfWeek
        dayOfMonth
        weekOfMonth
        monthInterval
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      additionalAvailabilities {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      blackoutDates {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      __typename
    }
    availabilitiesNote
    emails
    profileImages {
      type
      name
      order
      s3Prefix
      widthInInches
      heightInInches
      __typename
    }
    qmeReportConfigs {
      hasIntroTitle
      introTemplate
      __typename
    }
    physicalEvalConfigs {
      templates
      __typename
    }
    signatureDepartment
    profileAssetS3Prefix
    calendarPreference {
      mailingList
      showPatientFullName
      showPatientAddress
      showPatientDOB
      showPortalLink
      __typename
    }
    homeOffice {
      county
      state
      __typename
    }
    reportFormatPreferences {
      evaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      reEvaluationReport {
        sections
        assessmentSubSections
        __typename
      }
      supplementalReport {
        sections
        assessmentSubSections
        __typename
      }
      __typename
    }
    evaluationInputPreferences {
      evaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      reEvaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      supplementalReport {
        assessment
        __typename
      }
      __typename
    }
    preferredAssessmentMode
    caseSummaryFields {
      items {
        id
        doctorId
        caseSummaryFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        caseSummaryField {
          id
          name
          default
          description
          summaryPrompt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    briefingFields {
      items {
        id
        doctorId
        briefingFieldId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        briefingField {
          id
          name
          default
          description
          briefingPrompt
          briefingRecordTypeID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    isDemo
    fieldTemplateId
    templateFolderLink
    physicianPartner {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPrimaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSecondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultScheduler {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultPreVisitReviewer {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultBillingOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    defaultSupplementalReportOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    supplementalReportOpsAssignments {
      medicalAssistantID
      weightPercentage
      __typename
    }
    supportingMAs {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    defaultAppointmentDurationMinutes {
      qme
      qmeReevaluation
      ime
      deposition
      __typename
    }
    defaultEarlyArrivalTimeMinutes {
      workersComp
      ime
      deposition
      __typename
    }
    assessmentTreatmentOptions
    dismissedProTips
    createdAt
    updatedAt
    doctorPhysicianPartnerId
    doctorDefaultPrimaryOnsiteOpsId
    doctorDefaultSecondaryOnsiteOpsId
    doctorDefaultSchedulerId
    doctorDefaultReportOpsId
    doctorDefaultPreVisitReviewerId
    doctorDefaultBillingOpsId
    doctorDefaultSupplementalReportOpsId
    doctorUserId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDoctorSubscriptionVariables,
  APITypes.OnUpdateDoctorSubscription
>;
export const onDeleteLocation = /* GraphQL */ `subscription OnDeleteLocation($filter: ModelSubscriptionLocationFilterInput) {
  onDeleteLocation(filter: $filter) {
    id
    name
    abbreviation
    status
    region
    address {
      street
      city
      state
      zip
      county
      __typename
    }
    indigoOfficePhoneNumber
    isWaitingArea
    additionalRoomsNumber
    landlordContactInfo {
      name
      phone
      email
      __typename
    }
    calendarCcEmails
    isParkingFree
    parkingRate
    isFrontDoorLocked
    frontDoorCode
    backDoor
    backDoorCode
    securityUnlockingProcess
    securityLockingProcess
    maleBathroomCode
    femaleBathroomCode
    wifiName
    wifiPassword
    defaultOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    secondaryOnsiteOps {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    locationInstructionsForVisitor
    additionalNote
    doctors {
      items {
        id
        doctorId
        locationId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        createdAt
        updatedAt
        ownerCognitoId
        __typename
      }
      nextToken
      __typename
    }
    appointments {
      items {
        id
        doctorOwnerCognitoId
        assistantCognitoIds
        globalPartitionKey
        originalAppointmentID
        supplementalAppointmentIDs
        supplementalSourceAppointmentIDs
        depositionAppointmentIDs
        depositionSourceAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        yearMonth
        doctorYearMonth
        time
        bookedInFlexibleTime
        inquiryDate
        inquiryYearMonth
        type
        doctorID
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        locationID
        location {
          id
          name
          abbreviation
          status
          region
          indigoOfficePhoneNumber
          isWaitingArea
          additionalRoomsNumber
          calendarCcEmails
          isParkingFree
          parkingRate
          isFrontDoorLocked
          frontDoorCode
          backDoor
          backDoorCode
          securityUnlockingProcess
          securityLockingProcess
          maleBathroomCode
          femaleBathroomCode
          wifiName
          wifiPassword
          locationInstructionsForVisitor
          additionalNote
          createdAt
          updatedAt
          locationDefaultOnsiteOpsId
          locationSecondaryOnsiteOpsId
          __typename
        }
        visitForm
        jotformSubmissions {
          id
          receivedAt
          populatedAt
          __typename
        }
        historyTranscriptPopulations {
          uploadedFileID
          populatedAt
          __typename
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        paymentStatus
        billingStatus
        difficultyLevel
        scheduler {
          name
          organizationName
          __typename
        }
        medicalAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        onSiteOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        reportOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        billingOp {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        preVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        inquirerInfo {
          inquiringParty
          name
          inquiryDate
          notification_110_required
          __typename
        }
        notes {
          nextToken
          __typename
        }
        huddleNote {
          id
          appointmentRecordID
          contentMarkdown
          createdAt
          updatedAt
          __typename
        }
        patientCases {
          nextToken
          __typename
        }
        employments {
          employerName
          jobTitle
          dateOfHire
          hoursPerWeek
          jobDuties
          dateOfTermination
          notes
          stillWorkingHere
          type
          currentWorkRestrictions
          workStatus
          departureReason
          __typename
        }
        employmentGaps {
          type
          notes
          __typename
        }
        patientDescribedInjuries
        uploadedFilesSet {
          id
          createdAt
          updatedAt
          __typename
        }
        uploadedFilesSetID
        referredBy
        s3FileKey
        medicalRecordsReceived
        medicalRecordsBriefingFileID
        medicalRecordsBriefingExecutionArn
        medicalRecordsTotalPagesProcessed
        reportGenerationFileID
        reportGenerationExecutionArn
        reportGenerationGeneratedAt
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        evaluationFileID
        assessmentFileID
        depositionPreparationFileID
        documentStatus {
          evaluationPublished
          assessmentPublished
          historyInProgress
          historyPublished
          historyCleaned
          reportPublished
          briefingInProgress
          briefingPublished
          briefingCleaned
          __typename
        }
        cancellationReason
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationNote
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        noShowNote
        reschedulingReason
        reschedulingOthersReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingNote
        reschedulingDate
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        historyOfInjuryNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        currentComplaintNotes {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        historyCallDate
        historyCallTime
        historyCallAssistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        historyCallCalendarEventID
        historyCallCalendarLink
        billingInfo {
          totalCharge
          amountPaid
          billingCounter
          billedDate
          paidDate
          correctionDate
          __typename
        }
        caseInfo {
          __typename
        }
        isProd
        isDemo
        primaryPatientCaseID
        calendarEventID
        reportConfiguration {
          history
          physicalExamination
          assessment
          __typename
        }
        workflowExecutions {
          nextToken
          __typename
        }
        historyOfInjuryInsights {
          id
          appointmentRecordID
          mechanismOfInjury
          employerJobDescription
          injuryEmploymentStatus
          currentWorkRestrictionsFromPatient
          activitiesOfDailyLiving
          createdAt
          updatedAt
          __typename
        }
        reviewOfMedicalRecordsInsights {
          id
          appointmentRecordID
          currentWorkRestrictionsFromMedicalRecords
          derivedFromDocumentInsightIDs
          derivedAt
          createdAt
          updatedAt
          __typename
        }
        physicalExamInsights {
          id
          appointmentRecordID
          physicalExaminationInfo
          createdAt
          updatedAt
          __typename
        }
        pastInjuryMatrix {
          id
          appointmentRecordID
          preExistingConditions
          familyHistory
          createdAt
          updatedAt
          __typename
        }
        briefing {
          id
          logicalBriefingID
          generatedAt
          lastEditedAt
          lastEditedBy
          googleDocExportLink
          googleDocExportedAt
          editingPresence
          createdAt
          updatedAt
          __typename
        }
        introParagraph {
          id
          appointmentRecordID
          introParagraphText
          status
          errorMessage
          generatedAt
          lastEditedAt
          lastEditedBy
          createdAt
          updatedAt
          __typename
        }
        impairmentRatingResults {
          ts
          bodyParts
          enabledStrictRating
          enabledPainRating
          enabledAG
          enabledStrengthRating
          enabledDBE
          autoMode
          result
          __typename
        }
        defenseAttorneyPagesDeclaration
        applicantAttorneyPagesDeclaration
        fieldTemplateRef {
          id
          version
          __typename
        }
        dataFieldValuesMappings {
          dataFieldID
          value
          __typename
        }
        physicalEvalTemplateRef {
          id
          version
          __typename
        }
        physicalExamValues {
          sectionID
          questionID
          side
          value
          note
          excluded
          __typename
        }
        physicalExamOtherFindings {
          sectionID
          text
          __typename
        }
        assessment {
          id
          discussedBodyParts
          bodyPartsNotDiscussedReason
          discussions
          workStatus
          markedAsDone
          discussDiagnosesFreeForm
          diagnosesFreeform
          discussCausationFreeForm
          causationFreeForm
          discussMMIImpairmentRatingApportionmentFreeForm
          hasPatientReachedMMIFreeForm
          discussMMIByBodyPartFreeForm
          impairmentRatingByBodyPartFreeForm
          apportionmentByBodyPartFreeForm
          impairmentRatingOtherComments
          apportionmentOtherComments
          assessmentMode
          createdAt
          updatedAt
          __typename
        }
        assessmentValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        opinionRecap {
          id
          appointmentRecordID
          causation
          diagnosis
          mmiFutureMedicalTreatment
          impairmentRating
          apportionment
          workStatus
          sourceReportFileID
          createdAt
          updatedAt
          __typename
        }
        tempUploadedIntakeFormS3Keys
        featureFlags {
          featureFlagKey
          enabled
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
        panelUnavailable
        panelSpecialty
        defenseAttorneyNotPresent
        applicantAttorneyNotPresent
        contactUnavailability {
          __typename
        }
        historyValidation {
          id
          appointmentRecordID
          status
          validatedAt
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        patientHistoryValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        videoCallLink
        additionalTimeslots {
          date
          time
          locationID
          __typename
        }
        mrrValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        historyMrrCrossValidation {
          id
          issueGroups
          createdAt
          updatedAt
          __typename
        }
        caseID
        briefingModelVersion
        briefingGdocExportLink
        briefingGdocExportedAt
        createdAt
        updatedAt
        appointmentRecordMedicalAssistantId
        appointmentRecordSchedulingAssistantId
        appointmentRecordOnSiteOpId
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        appointmentRecordHuddleNoteId
        appointmentRecordHistoryOfInjuryNotesId
        appointmentRecordCurrentComplaintNotesId
        appointmentRecordHistoryCallAssistantId
        appointmentRecordHistoryOfInjuryInsightsId
        appointmentRecordReviewOfMedicalRecordsInsightsId
        appointmentRecordPhysicalExamInsightsId
        appointmentRecordPastInjuryMatrixId
        appointmentRecordBriefingId
        appointmentRecordIntroParagraphId
        appointmentRecordAssessmentId
        appointmentRecordAssessmentValidationId
        appointmentRecordOpinionRecapId
        appointmentRecordHistoryValidationId
        appointmentRecordPatientHistoryValidationId
        appointmentRecordMrrValidationId
        appointmentRecordHistoryMrrCrossValidationId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    locationDefaultOnsiteOpsId
    locationSecondaryOnsiteOpsId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLocationSubscriptionVariables,
  APITypes.OnDeleteLocationSubscription
>;
export const onCreateWorkflowExecution = /* GraphQL */ `subscription OnCreateWorkflowExecution(
  $filter: ModelSubscriptionWorkflowExecutionFilterInput
) {
  onCreateWorkflowExecution(filter: $filter) {
    executionArn
    appointmentRecordID
    type
    status
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWorkflowExecutionSubscriptionVariables,
  APITypes.OnCreateWorkflowExecutionSubscription
>;
export const onUpdateWorkflowExecution = /* GraphQL */ `subscription OnUpdateWorkflowExecution(
  $filter: ModelSubscriptionWorkflowExecutionFilterInput
) {
  onUpdateWorkflowExecution(filter: $filter) {
    executionArn
    appointmentRecordID
    type
    status
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateWorkflowExecutionSubscriptionVariables,
  APITypes.OnUpdateWorkflowExecutionSubscription
>;
export const onDeleteWorkflowExecution = /* GraphQL */ `subscription OnDeleteWorkflowExecution(
  $filter: ModelSubscriptionWorkflowExecutionFilterInput
) {
  onDeleteWorkflowExecution(filter: $filter) {
    executionArn
    appointmentRecordID
    type
    status
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteWorkflowExecutionSubscriptionVariables,
  APITypes.OnDeleteWorkflowExecutionSubscription
>;
export const onUpdateHistoryOfInjuryInsights = /* GraphQL */ `subscription OnUpdateHistoryOfInjuryInsights(
  $filter: ModelSubscriptionHistoryOfInjuryInsightsFilterInput
) {
  onUpdateHistoryOfInjuryInsights(filter: $filter) {
    id
    appointmentRecordID
    mechanismOfInjury
    employerJobDescription
    injuryCausations {
      injuryType
      dateOfInjury
      dateOfInjuryEnd
      bodyParts
      mechanismOfInjury
      employerJobDescription
      __typename
    }
    currentSymptoms {
      bodyParts
      description
      __typename
    }
    priorSymptomsBeforeCurrentInjury {
      bodyParts
      description
      __typename
    }
    previousSurgeries {
      date
      bodyParts
      type
      __typename
    }
    previousWorkInjuries {
      date
      bodyParts
      description
      __typename
    }
    previousInjuries {
      date
      bodyParts
      description
      __typename
    }
    injuryEmploymentStatus
    currentWorkRestrictionsFromPatient
    activitiesOfDailyLiving
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHistoryOfInjuryInsightsSubscriptionVariables,
  APITypes.OnUpdateHistoryOfInjuryInsightsSubscription
>;
export const onUpdateReviewOfMedicalRecordsInsights = /* GraphQL */ `subscription OnUpdateReviewOfMedicalRecordsInsights(
  $filter: ModelSubscriptionReviewOfMedicalRecordsInsightsFilterInput
) {
  onUpdateReviewOfMedicalRecordsInsights(filter: $filter) {
    id
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    derivedFromDocumentInsightIDs
    derivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateReviewOfMedicalRecordsInsightsSubscriptionVariables,
  APITypes.OnUpdateReviewOfMedicalRecordsInsightsSubscription
>;
export const onCreateDocumentBriefingInsights = /* GraphQL */ `subscription OnCreateDocumentBriefingInsights(
  $filter: ModelSubscriptionDocumentBriefingInsightsFilterInput
) {
  onCreateDocumentBriefingInsights(filter: $filter) {
    id
    documentID
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    sourceRecordBriefingID
    generatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDocumentBriefingInsightsSubscriptionVariables,
  APITypes.OnCreateDocumentBriefingInsightsSubscription
>;
export const onUpdateDocumentBriefingInsights = /* GraphQL */ `subscription OnUpdateDocumentBriefingInsights(
  $filter: ModelSubscriptionDocumentBriefingInsightsFilterInput
) {
  onUpdateDocumentBriefingInsights(filter: $filter) {
    id
    documentID
    appointmentRecordID
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        year
        treatmentType
        frequency
        description
        __typename
      }
      __typename
    }
    currentWorkRestrictionsFromMedicalRecords
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    durableMedicalEquipment {
      startDate
      endDate
      bodyParts
      equipmentType
      description
      __typename
    }
    sourceRecordBriefingID
    generatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDocumentBriefingInsightsSubscriptionVariables,
  APITypes.OnUpdateDocumentBriefingInsightsSubscription
>;
export const onUpdatePhysicalExamInsights = /* GraphQL */ `subscription OnUpdatePhysicalExamInsights(
  $filter: ModelSubscriptionPhysicalExamInsightsFilterInput
) {
  onUpdatePhysicalExamInsights(filter: $filter) {
    id
    appointmentRecordID
    physicalExaminationInfo
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePhysicalExamInsightsSubscriptionVariables,
  APITypes.OnUpdatePhysicalExamInsightsSubscription
>;
export const onCreateAppointmentFilterPreset = /* GraphQL */ `subscription OnCreateAppointmentFilterPreset(
  $filter: ModelSubscriptionAppointmentFilterPresetFilterInput
) {
  onCreateAppointmentFilterPreset(filter: $filter) {
    id
    name
    filters {
      type
      values
      __typename
    }
    appliesTo
    view
    users {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAppointmentFilterPresetSubscriptionVariables,
  APITypes.OnCreateAppointmentFilterPresetSubscription
>;
export const onDeleteAppointmentFilterPreset = /* GraphQL */ `subscription OnDeleteAppointmentFilterPreset(
  $filter: ModelSubscriptionAppointmentFilterPresetFilterInput
) {
  onDeleteAppointmentFilterPreset(filter: $filter) {
    id
    name
    filters {
      type
      values
      __typename
    }
    appliesTo
    view
    users {
      items {
        id
        userId
        appointmentFilterPresetId
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        appointmentFilterPreset {
          id
          name
          appliesTo
          view
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAppointmentFilterPresetSubscriptionVariables,
  APITypes.OnDeleteAppointmentFilterPresetSubscription
>;
export const onCreateRecordBriefingSegment = /* GraphQL */ `subscription OnCreateRecordBriefingSegment(
  $filter: ModelSubscriptionRecordBriefingSegmentFilterInput
) {
  onCreateRecordBriefingSegment(filter: $filter) {
    id
    logicalSegmentID
    title
    text
    bodyParts
    injuredBodyParts
    editedBy
    pdfFileName
    sourceTag
    segmentNumber
    sourcePdfS3Key
    startPageNumber
    endPageNumber
    recordType
    extractedDate
    doctorName
    processingModel
    classificationConfidence
    hasDate
    potentialDuplicateID
    needsReview
    status
    documentID
    videoStartTime
    videoEndTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRecordBriefingSegmentSubscriptionVariables,
  APITypes.OnCreateRecordBriefingSegmentSubscription
>;
export const onUpdateRecordBriefingSegment = /* GraphQL */ `subscription OnUpdateRecordBriefingSegment(
  $filter: ModelSubscriptionRecordBriefingSegmentFilterInput
) {
  onUpdateRecordBriefingSegment(filter: $filter) {
    id
    logicalSegmentID
    title
    text
    bodyParts
    injuredBodyParts
    editedBy
    pdfFileName
    sourceTag
    segmentNumber
    sourcePdfS3Key
    startPageNumber
    endPageNumber
    recordType
    extractedDate
    doctorName
    processingModel
    classificationConfidence
    hasDate
    potentialDuplicateID
    needsReview
    status
    documentID
    videoStartTime
    videoEndTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRecordBriefingSegmentSubscriptionVariables,
  APITypes.OnUpdateRecordBriefingSegmentSubscription
>;
export const onDeleteRecordBriefingSegment = /* GraphQL */ `subscription OnDeleteRecordBriefingSegment(
  $filter: ModelSubscriptionRecordBriefingSegmentFilterInput
) {
  onDeleteRecordBriefingSegment(filter: $filter) {
    id
    logicalSegmentID
    title
    text
    bodyParts
    injuredBodyParts
    editedBy
    pdfFileName
    sourceTag
    segmentNumber
    sourcePdfS3Key
    startPageNumber
    endPageNumber
    recordType
    extractedDate
    doctorName
    processingModel
    classificationConfidence
    hasDate
    potentialDuplicateID
    needsReview
    status
    documentID
    videoStartTime
    videoEndTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRecordBriefingSegmentSubscriptionVariables,
  APITypes.OnDeleteRecordBriefingSegmentSubscription
>;
export const onUpdateRecordBriefingSegmentMapping = /* GraphQL */ `subscription OnUpdateRecordBriefingSegmentMapping(
  $filter: ModelSubscriptionRecordBriefingSegmentMappingFilterInput
) {
  onUpdateRecordBriefingSegmentMapping(filter: $filter) {
    id
    briefingID
    logicalSegmentID
    publishedSegmentID
    draftSegmentID
    markedForDeletion
    markedForCreation
    publishedSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    draftSegment {
      id
      logicalSegmentID
      title
      text
      bodyParts
      injuredBodyParts
      editedBy
      pdfFileName
      sourceTag
      segmentNumber
      sourcePdfS3Key
      startPageNumber
      endPageNumber
      recordType
      extractedDate
      doctorName
      processingModel
      classificationConfidence
      hasDate
      potentialDuplicateID
      needsReview
      status
      documentID
      videoStartTime
      videoEndTime
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRecordBriefingSegmentMappingSubscriptionVariables,
  APITypes.OnUpdateRecordBriefingSegmentMappingSubscription
>;
export const onUpdateRecordBriefing = /* GraphQL */ `subscription OnUpdateRecordBriefing(
  $filter: ModelSubscriptionRecordBriefingFilterInput
) {
  onUpdateRecordBriefing(filter: $filter) {
    id
    logicalBriefingID
    segmentMappings {
      items {
        id
        briefingID
        logicalSegmentID
        publishedSegmentID
        draftSegmentID
        markedForDeletion
        markedForCreation
        publishedSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        draftSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    generatedAt
    lastEditedAt
    lastEditedBy
    googleDocExportLink
    googleDocExportedAt
    suggestionGeneration {
      status
      jobId
      startedAt
      completedAt
      error
      __typename
    }
    editingPresence
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRecordBriefingSubscriptionVariables,
  APITypes.OnUpdateRecordBriefingSubscription
>;
export const onUpdateSummaryCitation = /* GraphQL */ `subscription OnUpdateSummaryCitation(
  $filter: ModelSubscriptionSummaryCitationFilterInput
) {
  onUpdateSummaryCitation(filter: $filter) {
    id
    briefingID
    logicalSegmentID
    summaryText
    citationID
    status
    removedBy
    removedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSummaryCitationSubscriptionVariables,
  APITypes.OnUpdateSummaryCitationSubscription
>;
export const onDeleteSummaryCitation = /* GraphQL */ `subscription OnDeleteSummaryCitation(
  $filter: ModelSubscriptionSummaryCitationFilterInput
) {
  onDeleteSummaryCitation(filter: $filter) {
    id
    briefingID
    logicalSegmentID
    summaryText
    citationID
    status
    removedBy
    removedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteSummaryCitationSubscriptionVariables,
  APITypes.OnDeleteSummaryCitationSubscription
>;
export const onCreateCoverLetterRecap = /* GraphQL */ `subscription OnCreateCoverLetterRecap(
  $filter: ModelSubscriptionCoverLetterRecapFilterInput
) {
  onCreateCoverLetterRecap(filter: $filter) {
    id
    uploadedFileID
    recapText
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCoverLetterRecapSubscriptionVariables,
  APITypes.OnCreateCoverLetterRecapSubscription
>;
export const onUpdateCoverLetterRecap = /* GraphQL */ `subscription OnUpdateCoverLetterRecap(
  $filter: ModelSubscriptionCoverLetterRecapFilterInput
) {
  onUpdateCoverLetterRecap(filter: $filter) {
    id
    uploadedFileID
    recapText
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCoverLetterRecapSubscriptionVariables,
  APITypes.OnUpdateCoverLetterRecapSubscription
>;
export const onDeleteCoverLetterRecap = /* GraphQL */ `subscription OnDeleteCoverLetterRecap(
  $filter: ModelSubscriptionCoverLetterRecapFilterInput
) {
  onDeleteCoverLetterRecap(filter: $filter) {
    id
    uploadedFileID
    recapText
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCoverLetterRecapSubscriptionVariables,
  APITypes.OnDeleteCoverLetterRecapSubscription
>;
export const onCreateIntroParagraph = /* GraphQL */ `subscription OnCreateIntroParagraph(
  $filter: ModelSubscriptionIntroParagraphFilterInput
) {
  onCreateIntroParagraph(filter: $filter) {
    id
    appointmentRecordID
    introParagraphText
    sourceRecaps {
      coverLetterRecapID
      uploadedFileID
      recapText
      generatedAt
      __typename
    }
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateIntroParagraphSubscriptionVariables,
  APITypes.OnCreateIntroParagraphSubscription
>;
export const onUpdateIntroParagraph = /* GraphQL */ `subscription OnUpdateIntroParagraph(
  $filter: ModelSubscriptionIntroParagraphFilterInput
) {
  onUpdateIntroParagraph(filter: $filter) {
    id
    appointmentRecordID
    introParagraphText
    sourceRecaps {
      coverLetterRecapID
      uploadedFileID
      recapText
      generatedAt
      __typename
    }
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateIntroParagraphSubscriptionVariables,
  APITypes.OnUpdateIntroParagraphSubscription
>;
export const onDeleteIntroParagraph = /* GraphQL */ `subscription OnDeleteIntroParagraph(
  $filter: ModelSubscriptionIntroParagraphFilterInput
) {
  onDeleteIntroParagraph(filter: $filter) {
    id
    appointmentRecordID
    introParagraphText
    sourceRecaps {
      coverLetterRecapID
      uploadedFileID
      recapText
      generatedAt
      __typename
    }
    status
    errorMessage
    generatedAt
    lastEditedAt
    lastEditedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteIntroParagraphSubscriptionVariables,
  APITypes.OnDeleteIntroParagraphSubscription
>;
export const onCreateIntroductionStatement = /* GraphQL */ `subscription OnCreateIntroductionStatement(
  $filter: ModelSubscriptionIntroductionStatementFilterInput
) {
  onCreateIntroductionStatement(filter: $filter) {
    id
    appointmentRecordID
    kind
    text
    lastEditedAt
    lastEditedBy
    selectedCoverLetterFileID
    selectionConfirmedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateIntroductionStatementSubscriptionVariables,
  APITypes.OnCreateIntroductionStatementSubscription
>;
export const onUpdateIntroductionStatement = /* GraphQL */ `subscription OnUpdateIntroductionStatement(
  $filter: ModelSubscriptionIntroductionStatementFilterInput
) {
  onUpdateIntroductionStatement(filter: $filter) {
    id
    appointmentRecordID
    kind
    text
    lastEditedAt
    lastEditedBy
    selectedCoverLetterFileID
    selectionConfirmedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateIntroductionStatementSubscriptionVariables,
  APITypes.OnUpdateIntroductionStatementSubscription
>;
export const onDeleteIntroductionStatement = /* GraphQL */ `subscription OnDeleteIntroductionStatement(
  $filter: ModelSubscriptionIntroductionStatementFilterInput
) {
  onDeleteIntroductionStatement(filter: $filter) {
    id
    appointmentRecordID
    kind
    text
    lastEditedAt
    lastEditedBy
    selectedCoverLetterFileID
    selectionConfirmedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteIntroductionStatementSubscriptionVariables,
  APITypes.OnDeleteIntroductionStatementSubscription
>;
export const onUpdateAssessment = /* GraphQL */ `subscription OnUpdateAssessment(
  $filter: ModelSubscriptionAssessmentFilterInput
) {
  onUpdateAssessment(filter: $filter) {
    id
    injuries {
      injuryType
      dateOfInjury
      dateOfInjuryFlexible {
        value
        precision
        __typename
      }
      dateOfInjuryEnd
      dateOfInjuryEndFlexible {
        value
        precision
        __typename
      }
      bodyParts
      causeOfInjury
      causedByWork
      causedByWorkExplanation
      __typename
    }
    discussedBodyParts
    bodyPartsNotDiscussedReason
    discussions
    diagnoses {
      diagnosis
      icdCode
      evidenceSources
      evidence
      __typename
    }
    bodyPartMMIStatus {
      discussByBodyPart
      allBodyPartsMMI {
        mmi
        mmiReason
        expectedMMITimeRange
        expectedMMITimeRangeExplanation
        treatments
        treatmentsExplanation
        discussions
        impairmentRating
        impairmentRatingNotApplicable
        deferImpairmentRating
        deferImpairmentRatingReason
        apportionment
        apportionmentNotApplicable
        deferApportionment
        deferApportionmentReason
        __typename
      }
      bodyPartMMIStatuses {
        bodyPart
        evaluation {
          mmi
          mmiReason
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          treatments
          treatmentsExplanation
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          deferImpairmentRating
          deferImpairmentRatingReason
          apportionment
          apportionmentNotApplicable
          deferApportionment
          deferApportionmentReason
          __typename
        }
        __typename
      }
      __typename
    }
    workStatus
    markedAsDone
    discussDiagnosesFreeForm
    diagnosesFreeform
    discussCausationFreeForm
    causationFreeForm
    discussMMIImpairmentRatingApportionmentFreeForm
    hasPatientReachedMMIFreeForm
    discussMMIByBodyPartFreeForm
    impairmentRatingByBodyPartFreeForm
    apportionmentByBodyPartFreeForm
    impairmentRatingOtherComments
    apportionmentOtherComments
    assessmentMode
    assessmentFreeForm {
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussions
      diagnosesAndEvidence
      causation
      hasPatientReachedMMI
      discussMMIByBodyPart
      impairmentRatingByBodyPart
      apportionmentByBodyPart
      workStatus
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAssessmentSubscriptionVariables,
  APITypes.OnUpdateAssessmentSubscription
>;
export const onCreateValidationCheck = /* GraphQL */ `subscription OnCreateValidationCheck(
  $filter: ModelSubscriptionValidationCheckFilterInput
) {
  onCreateValidationCheck(filter: $filter) {
    id
    validationID
    checkType
    inputResourceURIs
    status
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateValidationCheckSubscriptionVariables,
  APITypes.OnCreateValidationCheckSubscription
>;
export const onUpdateValidationCheck = /* GraphQL */ `subscription OnUpdateValidationCheck(
  $filter: ModelSubscriptionValidationCheckFilterInput
) {
  onUpdateValidationCheck(filter: $filter) {
    id
    validationID
    checkType
    inputResourceURIs
    status
    issues {
      items {
        id
        validationID
        validationCheckID
        title
        issue
        status
        resourceURI
        issueGroup
        issueType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateValidationCheckSubscriptionVariables,
  APITypes.OnUpdateValidationCheckSubscription
>;
export const onUpdateValidationIssue = /* GraphQL */ `subscription OnUpdateValidationIssue(
  $filter: ModelSubscriptionValidationIssueFilterInput
) {
  onUpdateValidationIssue(filter: $filter) {
    id
    validationID
    validationCheckID
    title
    issue
    status
    resourceURI
    issueGroup
    issueType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateValidationIssueSubscriptionVariables,
  APITypes.OnUpdateValidationIssueSubscription
>;
export const onCreateWorkflowAuditEntry = /* GraphQL */ `subscription OnCreateWorkflowAuditEntry(
  $filter: ModelSubscriptionWorkflowAuditEntryFilterInput
) {
  onCreateWorkflowAuditEntry(filter: $filter) {
    id
    workflowAuditID
    message
    actorType
    actorID
    entryType
    attachments {
      bucket
      key
      __typename
    }
    relatedActionIDs
    payload
    correlationID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWorkflowAuditEntrySubscriptionVariables,
  APITypes.OnCreateWorkflowAuditEntrySubscription
>;
export const onCreateHistoryValidation = /* GraphQL */ `subscription OnCreateHistoryValidation(
  $filter: ModelSubscriptionHistoryValidationFilterInput
) {
  onCreateHistoryValidation(filter: $filter) {
    id
    appointmentRecordID
    status
    groups {
      id
      title
      status
      issues {
        id
        title
        description
        patientInfoSection
        issueType
        __typename
      }
      __typename
    }
    validatedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateHistoryValidationSubscriptionVariables,
  APITypes.OnCreateHistoryValidationSubscription
>;
export const onUpdateHistoryValidation = /* GraphQL */ `subscription OnUpdateHistoryValidation(
  $filter: ModelSubscriptionHistoryValidationFilterInput
) {
  onUpdateHistoryValidation(filter: $filter) {
    id
    appointmentRecordID
    status
    groups {
      id
      title
      status
      issues {
        id
        title
        description
        patientInfoSection
        issueType
        __typename
      }
      __typename
    }
    validatedAt
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHistoryValidationSubscriptionVariables,
  APITypes.OnUpdateHistoryValidationSubscription
>;
export const onCreateZendeskTicket = /* GraphQL */ `subscription OnCreateZendeskTicket(
  $filter: ModelSubscriptionZendeskTicketFilterInput
) {
  onCreateZendeskTicket(filter: $filter) {
    id
    ticketID
    appointmentRecordID
    recipientParty
    isPrimary
    isTextTicket
    claimNumber
    version
    lastSyncedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateZendeskTicketSubscriptionVariables,
  APITypes.OnCreateZendeskTicketSubscription
>;
export const onUpdateZendeskTicket = /* GraphQL */ `subscription OnUpdateZendeskTicket(
  $filter: ModelSubscriptionZendeskTicketFilterInput
) {
  onUpdateZendeskTicket(filter: $filter) {
    id
    ticketID
    appointmentRecordID
    recipientParty
    isPrimary
    isTextTicket
    claimNumber
    version
    lastSyncedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateZendeskTicketSubscriptionVariables,
  APITypes.OnUpdateZendeskTicketSubscription
>;
export const onCreateAppointmentNotification = /* GraphQL */ `subscription OnCreateAppointmentNotification(
  $filter: ModelSubscriptionAppointmentNotificationFilterInput
) {
  onCreateAppointmentNotification(filter: $filter) {
    id
    appointmentRecordID
    entityType
    entityID
    notificationType
    channel
    recipientType
    recipientID
    recipientName
    title
    body
    status
    readAt
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAppointmentNotificationSubscriptionVariables,
  APITypes.OnCreateAppointmentNotificationSubscription
>;
export const onUpdateAppointmentNotification = /* GraphQL */ `subscription OnUpdateAppointmentNotification(
  $filter: ModelSubscriptionAppointmentNotificationFilterInput
) {
  onUpdateAppointmentNotification(filter: $filter) {
    id
    appointmentRecordID
    entityType
    entityID
    notificationType
    channel
    recipientType
    recipientID
    recipientName
    title
    body
    status
    readAt
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAppointmentNotificationSubscriptionVariables,
  APITypes.OnUpdateAppointmentNotificationSubscription
>;
export const onCreateSkill = /* GraphQL */ `subscription OnCreateSkill($filter: ModelSubscriptionSkillFilterInput) {
  onCreateSkill(filter: $filter) {
    id
    name
    description
    body
    scope
    ownerUserId
    roles
    inputs {
      name
      description
      required
      __typename
    }
    visibility
    version
    archivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSkillSubscriptionVariables,
  APITypes.OnCreateSkillSubscription
>;
export const onUpdateSkill = /* GraphQL */ `subscription OnUpdateSkill($filter: ModelSubscriptionSkillFilterInput) {
  onUpdateSkill(filter: $filter) {
    id
    name
    description
    body
    scope
    ownerUserId
    roles
    inputs {
      name
      description
      required
      __typename
    }
    visibility
    version
    archivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSkillSubscriptionVariables,
  APITypes.OnUpdateSkillSubscription
>;
export const onDeleteSkill = /* GraphQL */ `subscription OnDeleteSkill($filter: ModelSubscriptionSkillFilterInput) {
  onDeleteSkill(filter: $filter) {
    id
    name
    description
    body
    scope
    ownerUserId
    roles
    inputs {
      name
      description
      required
      __typename
    }
    visibility
    version
    archivedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteSkillSubscriptionVariables,
  APITypes.OnDeleteSkillSubscription
>;
export const onUpdateRoutine = /* GraphQL */ `subscription OnUpdateRoutine($filter: ModelSubscriptionRoutineFilterInput) {
  onUpdateRoutine(filter: $filter) {
    id
    scope
    name
    description
    promptBody
    model
    reasoningEffort
    enableWebSearch
    maxAgentTurns
    conversationMode
    schedule {
      frequency
      intervalHours
      timeOfDay
      weekdays
      runAt
      __typename
    }
    timezone
    enabled
    notifyOwner
    slackChannel
    ownerUserId
    createdAt
    createdVia
    version
    archivedAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRoutineSubscriptionVariables,
  APITypes.OnUpdateRoutineSubscription
>;
export const onUpdateRoutineState = /* GraphQL */ `subscription OnUpdateRoutineState(
  $filter: ModelSubscriptionRoutineStateFilterInput
) {
  onUpdateRoutineState(filter: $filter) {
    id
    scope
    ownerUserId
    definitionVersion
    schedulePartition
    nextRunAt
    currentConversationId
    activeRunId
    lastRunId
    consecutiveFailures
    endedReason
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRoutineStateSubscriptionVariables,
  APITypes.OnUpdateRoutineStateSubscription
>;
export const onUpdateRoutineRun = /* GraphQL */ `subscription OnUpdateRoutineRun(
  $filter: ModelSubscriptionRoutineRunFilterInput
) {
  onUpdateRoutineRun(filter: $filter) {
    id
    scope
    routineId
    routineVersion
    createdAt
    definitionSnapshot
    status
    trigger
    triggeredByUserId
    extraContext
    scheduledFor
    startedAt
    finishedAt
    durationMs
    processingStage
    nextProcessingAt
    dispatchAttempts
    lastDispatchedAt
    executionToken
    executionDeadlineAt
    conversationOwnerUserId
    conversationId
    previousConversationId
    userMessageId
    assistantMessageId
    outcome
    headline
    summary
    totalTokens
    agentTurns
    toolsCalled
    toolsFailed
    correlationId
    errorMessage
    ownerDelivery {
      status
      target
      claimToken
      claimExpiresAt
      attemptedAt
      finishedAt
      messageId
      errorMessage
      __typename
    }
    channelDelivery {
      status
      target
      claimToken
      claimExpiresAt
      attemptedAt
      finishedAt
      messageId
      errorMessage
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRoutineRunSubscriptionVariables,
  APITypes.OnUpdateRoutineRunSubscription
>;
export const onCreateDoctorSupportingMA = /* GraphQL */ `subscription OnCreateDoctorSupportingMA(
  $filter: ModelSubscriptionDoctorSupportingMAFilterInput
  $ownerCognitoId: String
) {
  onCreateDoctorSupportingMA(filter: $filter, ownerCognitoId: $ownerCognitoId) {
    id
    medicalAssistantId
    doctorId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDoctorSupportingMASubscriptionVariables,
  APITypes.OnCreateDoctorSupportingMASubscription
>;
export const onUpdateDoctorSupportingMA = /* GraphQL */ `subscription OnUpdateDoctorSupportingMA(
  $filter: ModelSubscriptionDoctorSupportingMAFilterInput
  $ownerCognitoId: String
) {
  onUpdateDoctorSupportingMA(filter: $filter, ownerCognitoId: $ownerCognitoId) {
    id
    medicalAssistantId
    doctorId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDoctorSupportingMASubscriptionVariables,
  APITypes.OnUpdateDoctorSupportingMASubscription
>;
export const onDeleteDoctorSupportingMA = /* GraphQL */ `subscription OnDeleteDoctorSupportingMA(
  $filter: ModelSubscriptionDoctorSupportingMAFilterInput
  $ownerCognitoId: String
) {
  onDeleteDoctorSupportingMA(filter: $filter, ownerCognitoId: $ownerCognitoId) {
    id
    medicalAssistantId
    doctorId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDoctorSupportingMASubscriptionVariables,
  APITypes.OnDeleteDoctorSupportingMASubscription
>;
export const onCreateMedicalAssistantSpecialtyCategory = /* GraphQL */ `subscription OnCreateMedicalAssistantSpecialtyCategory(
  $filter: ModelSubscriptionMedicalAssistantSpecialtyCategoryFilterInput
) {
  onCreateMedicalAssistantSpecialtyCategory(filter: $filter) {
    id
    medicalAssistantId
    specialtyCategoryId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    specialtyCategory {
      id
      name
      specialties
      fallbackMA {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      medicalAssistants {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      specialtyCategoryFallbackMAId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMedicalAssistantSpecialtyCategorySubscriptionVariables,
  APITypes.OnCreateMedicalAssistantSpecialtyCategorySubscription
>;
export const onUpdateMedicalAssistantSpecialtyCategory = /* GraphQL */ `subscription OnUpdateMedicalAssistantSpecialtyCategory(
  $filter: ModelSubscriptionMedicalAssistantSpecialtyCategoryFilterInput
) {
  onUpdateMedicalAssistantSpecialtyCategory(filter: $filter) {
    id
    medicalAssistantId
    specialtyCategoryId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    specialtyCategory {
      id
      name
      specialties
      fallbackMA {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      medicalAssistants {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      specialtyCategoryFallbackMAId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMedicalAssistantSpecialtyCategorySubscriptionVariables,
  APITypes.OnUpdateMedicalAssistantSpecialtyCategorySubscription
>;
export const onDeleteMedicalAssistantSpecialtyCategory = /* GraphQL */ `subscription OnDeleteMedicalAssistantSpecialtyCategory(
  $filter: ModelSubscriptionMedicalAssistantSpecialtyCategoryFilterInput
) {
  onDeleteMedicalAssistantSpecialtyCategory(filter: $filter) {
    id
    medicalAssistantId
    specialtyCategoryId
    medicalAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      enableCalendarNotify
      inactive
      languages
      assignmentCriteria {
        languageWeights {
          language
          weight
          doctorSpecialty
          __typename
        }
        __typename
      }
      isDemo
      dismissedProTips
      phoneNumber
      joinedDate
      level
      capacityPercent
      supportedDoctors {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      supportedSpecialtyCategories {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availabilityExceptions {
        type
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      roles
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    specialtyCategory {
      id
      name
      specialties
      fallbackMA {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      medicalAssistants {
        items {
          id
          medicalAssistantId
          specialtyCategoryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      specialtyCategoryFallbackMAId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMedicalAssistantSpecialtyCategorySubscriptionVariables,
  APITypes.OnDeleteMedicalAssistantSpecialtyCategorySubscription
>;
export const onCreateUserAppointmentFilterPreset = /* GraphQL */ `subscription OnCreateUserAppointmentFilterPreset(
  $filter: ModelSubscriptionUserAppointmentFilterPresetFilterInput
) {
  onCreateUserAppointmentFilterPreset(filter: $filter) {
    id
    userId
    appointmentFilterPresetId
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    appointmentFilterPreset {
      id
      name
      filters {
        type
        values
        __typename
      }
      appliesTo
      view
      users {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserAppointmentFilterPresetSubscriptionVariables,
  APITypes.OnCreateUserAppointmentFilterPresetSubscription
>;
export const onUpdateUserAppointmentFilterPreset = /* GraphQL */ `subscription OnUpdateUserAppointmentFilterPreset(
  $filter: ModelSubscriptionUserAppointmentFilterPresetFilterInput
) {
  onUpdateUserAppointmentFilterPreset(filter: $filter) {
    id
    userId
    appointmentFilterPresetId
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    appointmentFilterPreset {
      id
      name
      filters {
        type
        values
        __typename
      }
      appliesTo
      view
      users {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserAppointmentFilterPresetSubscriptionVariables,
  APITypes.OnUpdateUserAppointmentFilterPresetSubscription
>;
export const onDeleteUserAppointmentFilterPreset = /* GraphQL */ `subscription OnDeleteUserAppointmentFilterPreset(
  $filter: ModelSubscriptionUserAppointmentFilterPresetFilterInput
) {
  onDeleteUserAppointmentFilterPreset(filter: $filter) {
    id
    userId
    appointmentFilterPresetId
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    appointmentFilterPreset {
      id
      name
      filters {
        type
        values
        __typename
      }
      appliesTo
      view
      users {
        items {
          id
          userId
          appointmentFilterPresetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserAppointmentFilterPresetSubscriptionVariables,
  APITypes.OnDeleteUserAppointmentFilterPresetSubscription
>;
export const onCreateAppointmentRecordPatientCase = /* GraphQL */ `subscription OnCreateAppointmentRecordPatientCase(
  $filter: ModelSubscriptionAppointmentRecordPatientCaseFilterInput
  $doctorOwnerCognitoId: String
  $assistantCognitoIds: String
) {
  onCreateAppointmentRecordPatientCase(
    filter: $filter
    doctorOwnerCognitoId: $doctorOwnerCognitoId
    assistantCognitoIds: $assistantCognitoIds
  ) {
    id
    appointmentRecordId
    patientCaseId
    appointmentRecord {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    patientCase {
      id
      patientID
      patient {
        id
        name
        dateOfBirth
        SSN
        language
        dominantHand
        cases {
          nextToken
          __typename
        }
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        occupation
        sex
        weightLb
        height {
          feet
          inches
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      claimNumber
      qmePanelNumber
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      injuryInfo {
        injuryType
        injuredBodyParts
        claimedBodyParts
        description
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        startDateOfInjury
        startDateOfInjuryFlexible {
          value
          precision
          __typename
        }
        __typename
      }
      workersCompInsurance {
        insuranceCarrier
        adjuster
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      insuranceCarrierID
      insuranceCarrier {
        id
        name
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierAddressID
      insuranceCarrierAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierFaxNumberID
      insuranceCarrierFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierPhoneNumberID
      insuranceCarrierPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      appointments {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      applicantAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyLawFirmID
      applicantAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyAddressID
      applicantAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyFaxNumberID
      applicantAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyPhoneNumberID
      applicantAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      defenseAttorneyLawFirmID
      defenseAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyAddressID
      defenseAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyFaxNumberID
      defenseAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyPhoneNumberID
      defenseAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nurseCaseManager {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      ccPerson {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyCcEmails
      defenseAttorneyCcEmails
      adjusterCcEmails
      scheduledCommsSuppressedParties
      employmentAtInjury {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      WCAB
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    doctorOwnerCognitoId
    assistantCognitoIds
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAppointmentRecordPatientCaseSubscriptionVariables,
  APITypes.OnCreateAppointmentRecordPatientCaseSubscription
>;
export const onUpdateAppointmentRecordPatientCase = /* GraphQL */ `subscription OnUpdateAppointmentRecordPatientCase(
  $filter: ModelSubscriptionAppointmentRecordPatientCaseFilterInput
  $doctorOwnerCognitoId: String
  $assistantCognitoIds: String
) {
  onUpdateAppointmentRecordPatientCase(
    filter: $filter
    doctorOwnerCognitoId: $doctorOwnerCognitoId
    assistantCognitoIds: $assistantCognitoIds
  ) {
    id
    appointmentRecordId
    patientCaseId
    appointmentRecord {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    patientCase {
      id
      patientID
      patient {
        id
        name
        dateOfBirth
        SSN
        language
        dominantHand
        cases {
          nextToken
          __typename
        }
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        occupation
        sex
        weightLb
        height {
          feet
          inches
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      claimNumber
      qmePanelNumber
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      injuryInfo {
        injuryType
        injuredBodyParts
        claimedBodyParts
        description
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        startDateOfInjury
        startDateOfInjuryFlexible {
          value
          precision
          __typename
        }
        __typename
      }
      workersCompInsurance {
        insuranceCarrier
        adjuster
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      insuranceCarrierID
      insuranceCarrier {
        id
        name
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierAddressID
      insuranceCarrierAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierFaxNumberID
      insuranceCarrierFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierPhoneNumberID
      insuranceCarrierPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      appointments {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      applicantAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyLawFirmID
      applicantAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyAddressID
      applicantAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyFaxNumberID
      applicantAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyPhoneNumberID
      applicantAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      defenseAttorneyLawFirmID
      defenseAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyAddressID
      defenseAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyFaxNumberID
      defenseAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyPhoneNumberID
      defenseAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nurseCaseManager {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      ccPerson {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyCcEmails
      defenseAttorneyCcEmails
      adjusterCcEmails
      scheduledCommsSuppressedParties
      employmentAtInjury {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      WCAB
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    doctorOwnerCognitoId
    assistantCognitoIds
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAppointmentRecordPatientCaseSubscriptionVariables,
  APITypes.OnUpdateAppointmentRecordPatientCaseSubscription
>;
export const onDeleteAppointmentRecordPatientCase = /* GraphQL */ `subscription OnDeleteAppointmentRecordPatientCase(
  $filter: ModelSubscriptionAppointmentRecordPatientCaseFilterInput
  $doctorOwnerCognitoId: String
  $assistantCognitoIds: String
) {
  onDeleteAppointmentRecordPatientCase(
    filter: $filter
    doctorOwnerCognitoId: $doctorOwnerCognitoId
    assistantCognitoIds: $assistantCognitoIds
  ) {
    id
    appointmentRecordId
    patientCaseId
    appointmentRecord {
      id
      doctorOwnerCognitoId
      assistantCognitoIds
      globalPartitionKey
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      depositionAppointmentIDs
      depositionSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      yearMonth
      doctorYearMonth
      time
      bookedInFlexibleTime
      inquiryDate
      inquiryYearMonth
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        name
        signatureName
        status
        ramped
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        locations {
          nextToken
          __typename
        }
        specialties
        npi
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        availabilities {
          __typename
        }
        availabilitiesNote
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        reportFormatPreferences {
          __typename
        }
        evaluationInputPreferences {
          __typename
        }
        preferredAssessmentMode
        caseSummaryFields {
          nextToken
          __typename
        }
        briefingFields {
          nextToken
          __typename
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        isDemo
        fieldTemplateId
        templateFolderLink
        physicianPartner {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPrimaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSecondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultScheduler {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultPreVisitReviewer {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultBillingOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        defaultSupplementalReportOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        supplementalReportOpsAssignments {
          medicalAssistantID
          weightPercentage
          __typename
        }
        supportingMAs {
          nextToken
          __typename
        }
        defaultAppointmentDurationMinutes {
          qme
          qmeReevaluation
          ime
          deposition
          __typename
        }
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
        assessmentTreatmentOptions
        dismissedProTips
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        doctorDefaultPrimaryOnsiteOpsId
        doctorDefaultSecondaryOnsiteOpsId
        doctorDefaultSchedulerId
        doctorDefaultReportOpsId
        doctorDefaultPreVisitReviewerId
        doctorDefaultBillingOpsId
        doctorDefaultSupplementalReportOpsId
        doctorUserId
        __typename
      }
      locationID
      location {
        id
        name
        abbreviation
        status
        region
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        indigoOfficePhoneNumber
        isWaitingArea
        additionalRoomsNumber
        landlordContactInfo {
          name
          phone
          email
          __typename
        }
        calendarCcEmails
        isParkingFree
        parkingRate
        isFrontDoorLocked
        frontDoorCode
        backDoor
        backDoorCode
        securityUnlockingProcess
        securityLockingProcess
        maleBathroomCode
        femaleBathroomCode
        wifiName
        wifiPassword
        defaultOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        secondaryOnsiteOps {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        locationInstructionsForVisitor
        additionalNote
        doctors {
          nextToken
          __typename
        }
        appointments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        locationDefaultOnsiteOpsId
        locationSecondaryOnsiteOpsId
        __typename
      }
      visitForm
      jotformSubmissions {
        id
        receivedAt
        populatedAt
        __typename
      }
      historyTranscriptPopulations {
        uploadedFileID
        populatedAt
        __typename
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      paymentStatus
      billingStatus
      difficultyLevel
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      reportOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      billingOp {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      preVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        inquiringParty
        name
        inquiryDate
        notification_110_required
        __typename
      }
      notes {
        items {
          id
          content
          type
          timeStamp
          appointmentrecordID
          createdAt
          updatedAt
          notesAuthorId
          __typename
        }
        nextToken
        __typename
      }
      huddleNote {
        id
        appointmentRecordID
        contentMarkdown
        createdAt
        updatedAt
        __typename
      }
      patientCases {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      employments {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      employmentGaps {
        type
        startDate {
          value
          precision
          __typename
        }
        endDate {
          value
          precision
          __typename
        }
        notes
        __typename
      }
      patientDescribedInjuries
      uploadedFilesSet {
        id
        appointments {
          nextToken
          __typename
        }
        uploadedFiles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      uploadedFilesSetID
      referredBy
      s3FileKey
      medicalRecordsReceived
      medicalRecordsBriefingFileID
      medicalRecordsBriefingExecutionArn
      medicalRecordsTotalPagesProcessed
      reportGenerationFileID
      reportGenerationExecutionArn
      reportGenerationGeneratedAt
      historyOfInjuryFileID
      historyOfInjuryGeneratedAt
      evaluationFileID
      assessmentFileID
      depositionPreparationFileID
      documentStatus {
        evaluationPublished
        assessmentPublished
        historyInProgress
        historyPublished
        historyCleaned
        reportPublished
        briefingInProgress
        briefingPublished
        briefingCleaned
        __typename
      }
      cancellationReason
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationNote
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingReason
      reschedulingOthersReason
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingNote
      reschedulingDate
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      historyOfInjuryNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      currentComplaintNotes {
        id
        content
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        type
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallAssistant {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      historyCallCalendarEventID
      historyCallCalendarLink
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        billingCounter
        billedDate
        paidDate
        correctionDate
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      isProd
      isDemo
      primaryPatientCaseID
      calendarEventID
      reportConfiguration {
        history
        physicalExamination
        assessment
        __typename
      }
      workflowExecutions {
        items {
          executionArn
          appointmentRecordID
          type
          status
          errorMessage
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      historyOfInjuryInsights {
        id
        appointmentRecordID
        mechanismOfInjury
        employerJobDescription
        injuryCausations {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          mechanismOfInjury
          employerJobDescription
          __typename
        }
        currentSymptoms {
          bodyParts
          description
          __typename
        }
        priorSymptomsBeforeCurrentInjury {
          bodyParts
          description
          __typename
        }
        previousSurgeries {
          date
          bodyParts
          type
          __typename
        }
        previousWorkInjuries {
          date
          bodyParts
          description
          __typename
        }
        previousInjuries {
          date
          bodyParts
          description
          __typename
        }
        injuryEmploymentStatus
        currentWorkRestrictionsFromPatient
        activitiesOfDailyLiving
        createdAt
        updatedAt
        __typename
      }
      reviewOfMedicalRecordsInsights {
        id
        appointmentRecordID
        latestDiagnosis {
          bodyPart
          date
          descriptions
          __typename
        }
        diagnosticStudies {
          date
          typeOfStudy
          bodyPart
          impression
          source
          __typename
        }
        treatments {
          __typename
        }
        currentWorkRestrictionsFromMedicalRecords
        previousReports {
          date
          reportType
          reportContent
          __typename
        }
        durableMedicalEquipment {
          startDate
          endDate
          bodyParts
          equipmentType
          description
          __typename
        }
        derivedFromDocumentInsightIDs
        derivedAt
        createdAt
        updatedAt
        __typename
      }
      physicalExamInsights {
        id
        appointmentRecordID
        physicalExaminationInfo
        createdAt
        updatedAt
        __typename
      }
      pastInjuryMatrix {
        id
        appointmentRecordID
        preExistingConditions
        familyHistory
        injuryMatrix {
          date
          bodyPart
          status
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      briefing {
        id
        logicalBriefingID
        segmentMappings {
          nextToken
          __typename
        }
        generatedAt
        lastEditedAt
        lastEditedBy
        googleDocExportLink
        googleDocExportedAt
        suggestionGeneration {
          status
          jobId
          startedAt
          completedAt
          error
          __typename
        }
        editingPresence
        createdAt
        updatedAt
        __typename
      }
      introParagraph {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      impairmentRatingResults {
        ts
        bodyParts
        enabledStrictRating
        enabledPainRating
        enabledAG
        enabledStrengthRating
        enabledDBE
        autoMode
        result
        resultFeedback {
          exists
          isGood
          notes
          __typename
        }
        __typename
      }
      defenseAttorneyPagesDeclaration
      applicantAttorneyPagesDeclaration
      fieldTemplateRef {
        id
        version
        __typename
      }
      dataFieldValuesMappings {
        dataFieldID
        value
        __typename
      }
      physicalEvalTemplateRef {
        id
        version
        __typename
      }
      physicalExamValues {
        sectionID
        questionID
        side
        value
        note
        excluded
        __typename
      }
      physicalExamOtherFindings {
        sectionID
        text
        __typename
      }
      assessment {
        id
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryEnd
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussedBodyParts
        bodyPartsNotDiscussedReason
        discussions
        diagnoses {
          diagnosis
          icdCode
          evidenceSources
          evidence
          __typename
        }
        bodyPartMMIStatus {
          discussByBodyPart
          __typename
        }
        workStatus
        markedAsDone
        discussDiagnosesFreeForm
        diagnosesFreeform
        discussCausationFreeForm
        causationFreeForm
        discussMMIImpairmentRatingApportionmentFreeForm
        hasPatientReachedMMIFreeForm
        discussMMIByBodyPartFreeForm
        impairmentRatingByBodyPartFreeForm
        apportionmentByBodyPartFreeForm
        impairmentRatingOtherComments
        apportionmentOtherComments
        assessmentMode
        assessmentFreeForm {
          discussions
          diagnosesAndEvidence
          causation
          hasPatientReachedMMI
          discussMMIByBodyPart
          impairmentRatingByBodyPart
          apportionmentByBodyPart
          workStatus
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      assessmentValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      opinionRecap {
        id
        appointmentRecordID
        causation
        diagnosis
        mmiFutureMedicalTreatment
        impairmentRating
        apportionment
        workStatus
        sourceReportFileID
        createdAt
        updatedAt
        __typename
      }
      tempUploadedIntakeFormS3Keys
      featureFlags {
        featureFlagKey
        enabled
        __typename
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      panelUnavailable
      panelSpecialty
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
      historyValidation {
        id
        appointmentRecordID
        status
        groups {
          id
          title
          status
          __typename
        }
        validatedAt
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      patientHistoryValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      videoCallLink
      additionalTimeslots {
        date
        time
        locationID
        __typename
      }
      mrrValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      historyMrrCrossValidation {
        id
        issueGroups
        issues {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      caseID
      briefingModelVersion
      briefingGdocExportLink
      briefingGdocExportedAt
      createdAt
      updatedAt
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      appointmentRecordHuddleNoteId
      appointmentRecordHistoryOfInjuryNotesId
      appointmentRecordCurrentComplaintNotesId
      appointmentRecordHistoryCallAssistantId
      appointmentRecordHistoryOfInjuryInsightsId
      appointmentRecordReviewOfMedicalRecordsInsightsId
      appointmentRecordPhysicalExamInsightsId
      appointmentRecordPastInjuryMatrixId
      appointmentRecordBriefingId
      appointmentRecordIntroParagraphId
      appointmentRecordAssessmentId
      appointmentRecordAssessmentValidationId
      appointmentRecordOpinionRecapId
      appointmentRecordHistoryValidationId
      appointmentRecordPatientHistoryValidationId
      appointmentRecordMrrValidationId
      appointmentRecordHistoryMrrCrossValidationId
      __typename
    }
    patientCase {
      id
      patientID
      patient {
        id
        name
        dateOfBirth
        SSN
        language
        dominantHand
        cases {
          nextToken
          __typename
        }
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        occupation
        sex
        weightLb
        height {
          feet
          inches
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      claimNumber
      qmePanelNumber
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      injuryInfo {
        injuryType
        injuredBodyParts
        claimedBodyParts
        description
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        startDateOfInjury
        startDateOfInjuryFlexible {
          value
          precision
          __typename
        }
        __typename
      }
      workersCompInsurance {
        insuranceCarrier
        adjuster
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      insuranceCarrierID
      insuranceCarrier {
        id
        name
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierAddressID
      insuranceCarrierAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierFaxNumberID
      insuranceCarrierFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      insuranceCarrierPhoneNumberID
      insuranceCarrierPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      appointments {
        items {
          id
          appointmentRecordId
          patientCaseId
          createdAt
          updatedAt
          doctorOwnerCognitoId
          assistantCognitoIds
          __typename
        }
        nextToken
        __typename
      }
      applicantAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyLawFirmID
      applicantAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyAddressID
      applicantAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyFaxNumberID
      applicantAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      applicantAttorneyPhoneNumberID
      applicantAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorney {
        name
        lawFirmName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      defenseAttorneyLawFirmID
      defenseAttorneyLawFirm {
        id
        name
        type
        defaultAddressID
        defaultAddress {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        addresses {
          nextToken
          __typename
        }
        defaultFaxNumberID
        defaultFaxNumber {
          id
          faxNumber
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        faxNumbers {
          nextToken
          __typename
        }
        defaultPhoneNumberID
        defaultPhoneNumber {
          id
          phoneNumber
          extension
          insuranceCarrierID
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        phoneNumbers {
          nextToken
          __typename
        }
        defaultEmail
        supportedDomains
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyAddressID
      defenseAttorneyAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyFaxNumberID
      defenseAttorneyFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      defenseAttorneyPhoneNumberID
      defenseAttorneyPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nurseCaseManager {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      ccPerson {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        __typename
      }
      applicantAttorneyCcEmails
      defenseAttorneyCcEmails
      adjusterCcEmails
      scheduledCommsSuppressedParties
      employmentAtInjury {
        employerName
        jobTitle
        contact {
          phone
          phoneExtension
          email
          fax
          homePhoneNumber
          __typename
        }
        dateOfHire
        dateOfHireFlexible {
          value
          precision
          __typename
        }
        hoursPerWeek
        jobDuties
        dateOfTermination
        dateOfTerminationFlexible {
          value
          precision
          __typename
        }
        notes
        stillWorkingHere
        type
        currentWorkRestrictions
        workStatus
        departureReason
        __typename
      }
      WCAB
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    doctorOwnerCognitoId
    assistantCognitoIds
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAppointmentRecordPatientCaseSubscriptionVariables,
  APITypes.OnDeleteAppointmentRecordPatientCaseSubscription
>;
export const onCreateDoctorLocation = /* GraphQL */ `subscription OnCreateDoctorLocation(
  $filter: ModelSubscriptionDoctorLocationFilterInput
  $ownerCognitoId: String
) {
  onCreateDoctorLocation(filter: $filter, ownerCognitoId: $ownerCognitoId) {
    id
    doctorId
    locationId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDoctorLocationSubscriptionVariables,
  APITypes.OnCreateDoctorLocationSubscription
>;
export const onUpdateDoctorLocation = /* GraphQL */ `subscription OnUpdateDoctorLocation(
  $filter: ModelSubscriptionDoctorLocationFilterInput
  $ownerCognitoId: String
) {
  onUpdateDoctorLocation(filter: $filter, ownerCognitoId: $ownerCognitoId) {
    id
    doctorId
    locationId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDoctorLocationSubscriptionVariables,
  APITypes.OnUpdateDoctorLocationSubscription
>;
export const onDeleteDoctorLocation = /* GraphQL */ `subscription OnDeleteDoctorLocation(
  $filter: ModelSubscriptionDoctorLocationFilterInput
  $ownerCognitoId: String
) {
  onDeleteDoctorLocation(filter: $filter, ownerCognitoId: $ownerCognitoId) {
    id
    doctorId
    locationId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    location {
      id
      name
      abbreviation
      status
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      indigoOfficePhoneNumber
      isWaitingArea
      additionalRoomsNumber
      landlordContactInfo {
        name
        phone
        email
        __typename
      }
      calendarCcEmails
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      defaultOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      secondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      locationInstructionsForVisitor
      additionalNote
      doctors {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      locationDefaultOnsiteOpsId
      locationSecondaryOnsiteOpsId
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDoctorLocationSubscriptionVariables,
  APITypes.OnDeleteDoctorLocationSubscription
>;
export const onCreateDoctorCaseSummaryField = /* GraphQL */ `subscription OnCreateDoctorCaseSummaryField(
  $filter: ModelSubscriptionDoctorCaseSummaryFieldFilterInput
  $ownerCognitoId: String
) {
  onCreateDoctorCaseSummaryField(
    filter: $filter
    ownerCognitoId: $ownerCognitoId
  ) {
    id
    doctorId
    caseSummaryFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    caseSummaryField {
      id
      name
      default
      description
      summaryPrompt
      doctors {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDoctorCaseSummaryFieldSubscriptionVariables,
  APITypes.OnCreateDoctorCaseSummaryFieldSubscription
>;
export const onUpdateDoctorCaseSummaryField = /* GraphQL */ `subscription OnUpdateDoctorCaseSummaryField(
  $filter: ModelSubscriptionDoctorCaseSummaryFieldFilterInput
  $ownerCognitoId: String
) {
  onUpdateDoctorCaseSummaryField(
    filter: $filter
    ownerCognitoId: $ownerCognitoId
  ) {
    id
    doctorId
    caseSummaryFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    caseSummaryField {
      id
      name
      default
      description
      summaryPrompt
      doctors {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDoctorCaseSummaryFieldSubscriptionVariables,
  APITypes.OnUpdateDoctorCaseSummaryFieldSubscription
>;
export const onDeleteDoctorCaseSummaryField = /* GraphQL */ `subscription OnDeleteDoctorCaseSummaryField(
  $filter: ModelSubscriptionDoctorCaseSummaryFieldFilterInput
  $ownerCognitoId: String
) {
  onDeleteDoctorCaseSummaryField(
    filter: $filter
    ownerCognitoId: $ownerCognitoId
  ) {
    id
    doctorId
    caseSummaryFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    caseSummaryField {
      id
      name
      default
      description
      summaryPrompt
      doctors {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDoctorCaseSummaryFieldSubscriptionVariables,
  APITypes.OnDeleteDoctorCaseSummaryFieldSubscription
>;
export const onCreateDoctorBriefingField = /* GraphQL */ `subscription OnCreateDoctorBriefingField(
  $filter: ModelSubscriptionDoctorBriefingFieldFilterInput
  $ownerCognitoId: String
) {
  onCreateDoctorBriefingField(
    filter: $filter
    ownerCognitoId: $ownerCognitoId
  ) {
    id
    doctorId
    briefingFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    briefingField {
      id
      name
      default
      description
      briefingPrompt
      doctors {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingRecordTypeID
      recordType {
        id
        name
        recordType
        description
        default
        classificationPrompt
        recordBasePrompt
        briefingFields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDoctorBriefingFieldSubscriptionVariables,
  APITypes.OnCreateDoctorBriefingFieldSubscription
>;
export const onUpdateDoctorBriefingField = /* GraphQL */ `subscription OnUpdateDoctorBriefingField(
  $filter: ModelSubscriptionDoctorBriefingFieldFilterInput
  $ownerCognitoId: String
) {
  onUpdateDoctorBriefingField(
    filter: $filter
    ownerCognitoId: $ownerCognitoId
  ) {
    id
    doctorId
    briefingFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    briefingField {
      id
      name
      default
      description
      briefingPrompt
      doctors {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingRecordTypeID
      recordType {
        id
        name
        recordType
        description
        default
        classificationPrompt
        recordBasePrompt
        briefingFields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDoctorBriefingFieldSubscriptionVariables,
  APITypes.OnUpdateDoctorBriefingFieldSubscription
>;
export const onDeleteDoctorBriefingField = /* GraphQL */ `subscription OnDeleteDoctorBriefingField(
  $filter: ModelSubscriptionDoctorBriefingFieldFilterInput
  $ownerCognitoId: String
) {
  onDeleteDoctorBriefingField(
    filter: $filter
    ownerCognitoId: $ownerCognitoId
  ) {
    id
    doctorId
    briefingFieldId
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      name
      signatureName
      status
      ramped
      title
      titleExtension
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          county
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      appointments {
        items {
          id
          doctorOwnerCognitoId
          assistantCognitoIds
          globalPartitionKey
          originalAppointmentID
          supplementalAppointmentIDs
          supplementalSourceAppointmentIDs
          depositionAppointmentIDs
          depositionSourceAppointmentIDs
          rescheduledFromAppointmentID
          rescheduledToAppointmentID
          date
          yearMonth
          doctorYearMonth
          time
          bookedInFlexibleTime
          inquiryDate
          inquiryYearMonth
          type
          doctorID
          locationID
          visitForm
          active
          durationMinutes
          reportDue
          reportSubmitted
          status
          reportStatus
          paymentStatus
          billingStatus
          difficultyLevel
          patientDescribedInjuries
          uploadedFilesSetID
          referredBy
          s3FileKey
          medicalRecordsReceived
          medicalRecordsBriefingFileID
          medicalRecordsBriefingExecutionArn
          medicalRecordsTotalPagesProcessed
          reportGenerationFileID
          reportGenerationExecutionArn
          reportGenerationGeneratedAt
          historyOfInjuryFileID
          historyOfInjuryGeneratedAt
          evaluationFileID
          assessmentFileID
          depositionPreparationFileID
          cancellationReason
          cancellationRequestedBy
          cancellationRequestedInternally
          cancellationNote
          cancellationDate
          inquiryClosingReason
          inquiryClosingNote
          inquiryClosingDate
          noShowReason
          noShowNote
          reschedulingReason
          reschedulingOthersReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          reschedulingNote
          reschedulingDate
          historyCallDate
          historyCallTime
          historyCallCompleted
          historyCallCompletedWithoutRecords
          historyCallCompletedOnSite
          historyCallNoShow
          historyCallCalendarEventID
          historyCallCalendarLink
          isProd
          isDemo
          primaryPatientCaseID
          calendarEventID
          defenseAttorneyPagesDeclaration
          applicantAttorneyPagesDeclaration
          tempUploadedIntakeFormS3Keys
          panelUnavailable
          panelSpecialty
          defenseAttorneyNotPresent
          applicantAttorneyNotPresent
          videoCallLink
          caseID
          briefingModelVersion
          briefingGdocExportLink
          briefingGdocExportedAt
          createdAt
          updatedAt
          appointmentRecordMedicalAssistantId
          appointmentRecordSchedulingAssistantId
          appointmentRecordOnSiteOpId
          appointmentRecordReportOpId
          appointmentRecordBillingOpId
          appointmentRecordPreVisitReviewerId
          appointmentRecordHuddleNoteId
          appointmentRecordHistoryOfInjuryNotesId
          appointmentRecordCurrentComplaintNotesId
          appointmentRecordHistoryCallAssistantId
          appointmentRecordHistoryOfInjuryInsightsId
          appointmentRecordReviewOfMedicalRecordsInsightsId
          appointmentRecordPhysicalExamInsightsId
          appointmentRecordPastInjuryMatrixId
          appointmentRecordBriefingId
          appointmentRecordIntroParagraphId
          appointmentRecordAssessmentId
          appointmentRecordAssessmentValidationId
          appointmentRecordOpinionRecapId
          appointmentRecordHistoryValidationId
          appointmentRecordPatientHistoryValidationId
          appointmentRecordMrrValidationId
          appointmentRecordHistoryMrrCrossValidationId
          __typename
        }
        nextToken
        __typename
      }
      availabilities {
        generalAvailabilities {
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          startTime
          endTime
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      availabilitiesNote
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      qmeReportConfigs {
        hasIntroTitle
        introTemplate
        __typename
      }
      physicalEvalConfigs {
        templates
        __typename
      }
      signatureDepartment
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        reEvaluationReport {
          sections
          assessmentSubSections
          __typename
        }
        supplementalReport {
          sections
          assessmentSubSections
          __typename
        }
        __typename
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          name
          signatureName
          status
          ramped
          title
          titleExtension
          officePhone
          cellPhone
          clinicPhone
          workCity
          workState
          collectionRate
          licenseNumber
          licenseRenewalDate
          specialties
          npi
          availabilitiesNote
          emails
          signatureDepartment
          profileAssetS3Prefix
          preferredAssessmentMode
          isDemo
          fieldTemplateId
          templateFolderLink
          assessmentTreatmentOptions
          dismissedProTips
          createdAt
          updatedAt
          doctorPhysicianPartnerId
          doctorDefaultPrimaryOnsiteOpsId
          doctorDefaultSecondaryOnsiteOpsId
          doctorDefaultSchedulerId
          doctorDefaultReportOpsId
          doctorDefaultPreVisitReviewerId
          doctorDefaultBillingOpsId
          doctorDefaultSupplementalReportOpsId
          doctorUserId
          __typename
        }
        assistant {
          id
          name
          email
          preVisitCallScheduleLink
          enableCalendarNotify
          inactive
          languages
          isDemo
          dismissedProTips
          phoneNumber
          joinedDate
          level
          capacityPercent
          roles
          createdAt
          updatedAt
          medicalAssistantUserId
          __typename
        }
        appointmentFilterPreset {
          nextToken
          __typename
        }
        onboardingDismissals {
          itemId
          dismissedAt
          __typename
        }
        settings {
          opsChecklistDefaultExpanded
          __typename
        }
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      isDemo
      fieldTemplateId
      templateFolderLink
      physicianPartner {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPrimaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSecondaryOnsiteOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultScheduler {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultPreVisitReviewer {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultBillingOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      defaultSupplementalReportOps {
        id
        name
        email
        preVisitCallScheduleLink
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        enableCalendarNotify
        inactive
        languages
        assignmentCriteria {
          __typename
        }
        isDemo
        dismissedProTips
        phoneNumber
        joinedDate
        level
        capacityPercent
        supportedDoctors {
          nextToken
          __typename
        }
        supportedSpecialtyCategories {
          nextToken
          __typename
        }
        availabilityExceptions {
          type
          startTime
          endTime
          allDay
          __typename
        }
        roles
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      assessmentTreatmentOptions
      dismissedProTips
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      doctorDefaultPrimaryOnsiteOpsId
      doctorDefaultSecondaryOnsiteOpsId
      doctorDefaultSchedulerId
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      doctorDefaultSupplementalReportOpsId
      doctorUserId
      __typename
    }
    briefingField {
      id
      name
      default
      description
      briefingPrompt
      doctors {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          ownerCognitoId
          __typename
        }
        nextToken
        __typename
      }
      briefingRecordTypeID
      recordType {
        id
        name
        recordType
        description
        default
        classificationPrompt
        recordBasePrompt
        briefingFields {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    ownerCognitoId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDoctorBriefingFieldSubscriptionVariables,
  APITypes.OnDeleteDoctorBriefingFieldSubscription
>;
